import React from "react";
import "../styles/bio.css";
import childhood from "../assets/Toni-Kroos-childhood-photo.jpg";
import familyPhoto from "../assets/toni-kroos-family.webp";
import greifswald from "../assets/educat.jpg";
import youthFootball from "../assets/kroosEarly.webp";
import hansaRostock from "../assets/hansa.webp";
import bayernYouth from "../assets/toni bayern youth.webp";
import education from "../assets/15-years-old-Toni-Kroos-in-Rostock-playing-for-Hansa-FC-in-2005.jpg";
import preProfessional from "../assets/kroos bayer.jpg"; // You'll need to add this image

function Bio() {
  return (
    <section className="toni-kroos-earlyyears">
      <div className="container">
        <h2 className="section-title">The Early Years</h2>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <p>
                Born in Greifswald, Toni Kroos developed through youth football
                in northern Germany before joining Bayern Munich as a teenager.
              </p>
            </div>
            <div className="bio-img">
              <img src={childhood} alt="Toni Kroos as a child" />
            </div>
          </div>
        </div>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <h3>Birth & Family</h3>
              <p>
                Kroos was born on January 4, 1990, in Greifswald, then part of
                East Germany. His father, Roland, coached football, and his
                younger brother Felix also became a professional player.
              </p>
            </div>
            <div className="bio-img">
              <img src={familyPhoto} alt="Toni Kroos with his family" />
            </div>
          </div>
        </div>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <h3>Growing Up in Greifswald</h3>
              <p>
                Kroos grew up in Greifswald and began playing for local club
                Greifswalder SC. His father, Roland, was involved in coaching
                and helped introduce him to organized football.
              </p>
            </div>
            <div className="bio-img">
              <img src={greifswald} alt="Toni Kroos's hometown of Greifswald" />
            </div>
          </div>
        </div>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <h3>Introduction to Football</h3>
              <p>
                He started organized football at Greifswalder SC, his hometown
                club. At 12, he moved to Hansa Rostock's youth setup, taking the
                next step in his development.
              </p>
            </div>
            <div className="bio-img">
              <img
                src={youthFootball}
                alt="Young Toni Kroos playing football"
              />
            </div>
          </div>
        </div>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <h3>Hansa Rostock Years</h3>
              <p>
                Kroos joined Hansa Rostock in 2002 and played in the club's
                youth system. In 2006, he moved to Bayern Munich to continue his
                development.
              </p>
            </div>
            <div className="bio-img">
              <img src={hansaRostock} alt="Toni Kroos at Hansa Rostock" />
            </div>
          </div>
        </div>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <h3>Bayern Munich Youth Academy</h3>
              <p>
                Bayern signed Kroos from Hansa Rostock in 2006, when he was 16.
                He made his first-team debut the following year, aged 17.
              </p>
            </div>
            <div className="bio-img">
              <img
                src={bayernYouth}
                alt="Toni Kroos at Bayern Munich Youth Academy"
              />
            </div>
          </div>
        </div>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <h3>Education</h3>
              <p>
                Public biographies provide few reliable details about Kroos's
                schooling. His football path is clearer: he progressed from
                Greifswalder SC to Hansa Rostock and then Bayern Munich.
              </p>
            </div>
            <div className="bio-img">
              <img
                src={education}
                alt="Young Toni Kroos during his education"
              />
            </div>
          </div>
        </div>

        <div className="bio-section">
          <div className="bio-content">
            <div className="bio-text">
              <h3>Pre-Professional Transition</h3>
              <p>
                Kroos made his Bayern first-team debut in September 2007 at age
                17. He later gained Bundesliga experience on loan at Bayer
                Leverkusen before returning to Bayern.
              </p>
            </div>
            <div className="bio-img">
              <img
                src={preProfessional}
                alt="Toni Kroos in pre-professional days"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Bio;
